import { Button, Divider, Space } from 'antd'
import Link from 'antd/lib/typography/Link'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CustomInput, CustomSelectMenu } from '../../components'
import Template from '../../Template'
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';

const NewLead = () => {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({});
    const onChange = (e) => {
        setFormValues(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }
    console.log(formValues)
    const [country, setCountry] = useState('');
    const [region, setRegion] = useState('');
    const options = [
        {
            value: 'manager',
            label: 'Manager',
        },
        {
            value: 'user',
            label: 'User',
        }
    ]
    const onCountryChange = (val, name) => {
        name === 'country' ? setCountry(val) : setRegion(val);
        onChange({ target: { value: val, name } })
    }
    return (
        <Template
            useGoBack
            headerTitle={['Enquiry Dashboard', 'New lead']}
        >
            <div className='flex_ver'>
                <div style={{ display: 'flex', gap: 42, flexWrap: 'wrap' }}>
                    <CustomInput onChange={onChange} type='text' name="lead_name" label='Lead Name' />
                    <CustomInput onChange={onChange} type='text' name="phone" label='Phone' />
                    <CustomInput onChange={onChange} type='email' name="email" label='Email' />
                    <CustomSelectMenu placeholder='Campaign' name="campaign" onChange={onChange} options={options} />
                    <CountryDropdown className='region_selector' style={{ width: '100%', maxWidth: 320 }} classes='' defaultOptionLabel="Country" value={country} name='country' onChange={(val) => onCountryChange(val, 'country')} />
                    <RegionDropdown className='region_selector' blankOptionLabel="State" defaultOptionLabel="Select a state" country={country} value={region} name='state' onChange={(val) => onCountryChange(val, 'state')} />
                    <CustomInput onChange={onChange} type='text' name="city" label='City' />
                    <CustomInput onChange={onChange} type='text' name="status" label='Status' />
                    <CustomInput onChange={onChange} type='text' name="assignee" label='Assignee' />
                    <CustomInput onChange={onChange} type='text' name="programme" label='Programme' />

                </div>
                <Divider style={{ width: '100%' }} />
                <div style={{ display: 'flex', gap: 42, flexWrap: 'wrap' }}>
                    <CustomInput onChange={onChange} type='text' name="level" label='Level' />
                    <CustomInput onChange={onChange} type='text' name="level_1" label='Level_1' />
                    <CustomInput onChange={onChange} type='text' name="level_2" label='Level_2' />
                    <CustomInput onChange={onChange} type='text' name="level_3" label='Level_3' />
                    <CustomInput onChange={onChange} type='text' name="level_4" label='Level_4' />
                </div>
                <Divider style={{ width: '100%' }} />
                <Space >

                    <Button type="primary" style={{ width: 100 }}>
                        Save
                    </Button>

                    <Button style={{ width: 100, }} onClick={() => navigate(-1)}>Cancel</Button>
                </Space>
            </div>

        </Template>
    )
}

export default NewLead